<div class="style-guide-list-components">
  @if (isExpanded$ | async; as isExpanded) {
    <div class="content" [ngClass]="{ active: isExpanded === 'true' }">
      <button class="btn-link button-toggle" (click)="toggleMenu()">
        <span class="material-symbols-outlined">
          @if (isExpanded === 'true') {
            arrow_back_ios
          } @else {
            arrow_forward_ios
          }
        </span>
      </button>
      <ul>
        @for (component of components; track component) {
          <li>
            <button class="btn-link" (click)="scrollToSection(component.id)">{{ component.label }}</button>
          </li>
        }
      </ul>
    </div>
  }
</div>
